export const environment = {
  production: false,
  baseUrl: 'https://outliveapi.think201.xyz'
};
